/**
 * @deprecated This page is a legacy fallback from the redirect-based PayPal flow.
 * The primary payment flow now uses embedded PayPalButtons in RegistrationModal.
 * TODO: Remove this page once the embedded flow is fully validated in production.
 * Keep for now as a webhook fallback and edge-case compatibility path.
 */
import { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { AlertTriangle, ArrowLeft, Trophy } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export default function PaymentCancelledPage() {
  const [searchParams] = useSearchParams();
  const eventId = searchParams.get('eventId');

  // Clean up any pending registration data
  useEffect(() => {
    localStorage.removeItem('pendingRegistration');
  }, []);

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-yellow-500/10">
            <AlertTriangle className="h-8 w-8 text-yellow-600" />
          </div>
          <h2 className="text-xl font-bold">Payment Cancelled</h2>
          <p className="text-sm text-muted-foreground">
            No charges were made. Your registration was not completed.
          </p>
          <p className="text-xs text-muted-foreground">
            If you experienced an issue, please try again or contact support.
          </p>
          <div className="flex flex-col gap-2 pt-2 sm:flex-row">
            {eventId ? (
              <Link to={`/events/${eventId}`}>
                <Button className="w-full sm:w-auto">
                  <ArrowLeft className="mr-1 h-4 w-4" />
                  Return to Event
                </Button>
              </Link>
            ) : (
              <Link to="/dashboard">
                <Button className="w-full sm:w-auto">
                  <ArrowLeft className="mr-1 h-4 w-4" />
                  Go to Dashboard
                </Button>
              </Link>
            )}
            <Link to="/jackpots">
              <Button variant="outline" className="w-full sm:w-auto">
                <Trophy className="mr-1 h-4 w-4" />
                Browse Jackpots
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
